var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useStateService } from '@/shared/services/StateService';
import messages from './messages';
var NoRelationWarningIcon = function (_a) {
    var companyId = _a.companyId, intl = _a.intl;
    var stateService = useStateService();
    return (_jsx(OverlayTrigger, __assign({ placement: "right", overlay: _jsx(Tooltip, __assign({ id: "NoRelationWarning".concat(companyId) }, { children: intl.formatMessage(messages.NoRelationConfiguredInCompany) })) }, { children: _jsx("a", __assign({ href: stateService.getStateUrl('settings.company', { json: { companyId: companyId } }), onClick: function () { return stateService.gotoState('settings.company', { companyId: companyId }); } }, { children: _jsx("i", { className: "fa fa-exclamation-triangle fa-fw text-danger" }) })) })));
};
export default NoRelationWarningIcon;
